import { render, staticRenderFns } from "./KickOrBanUser.vue?vue&type=template&id=ee476da0&scoped=true&"
import script from "./KickOrBanUser.vue?vue&type=script&lang=js&"
export * from "./KickOrBanUser.vue?vue&type=script&lang=js&"
import style0 from "./KickOrBanUser.vue?vue&type=style&index=0&id=ee476da0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee476da0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee476da0')) {
      api.createRecord('ee476da0', component.options)
    } else {
      api.reload('ee476da0', component.options)
    }
    module.hot.accept("./KickOrBanUser.vue?vue&type=template&id=ee476da0&scoped=true&", function () {
      api.rerender('ee476da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/KickOrBanUser.vue"
export default component.exports